import axios from "axios"
import { createBrowserHistory } from 'history'
import {ACCESS_TOKEN, LOGIN_TYPE} from "@/common/Constant"
import {SvcUserData} from "@/service/UserService";

const data = { type: LOGIN_TYPE.EXPIRED};

export const history = createBrowserHistory();

export const apiClient = axios.create({
    baseURL: process.env.BACKEND_URI,
})

export const loginClient = axios.create({
     baseURL: process.env.BACKEND_URI,
 })

loginClient.interceptors.request.use(
    function (config){
        config.headers["Content-Type"] = 'application/json'
        return config;
    }
)

apiClient.interceptors.request.use(
    function (config){
        config.headers["Content-Type"] = 'application/json'
        config.headers["Authorization"] = `Bearer ${localStorage.getItem(ACCESS_TOKEN)?localStorage.getItem(ACCESS_TOKEN):''}`
        return config;
    }
)

loginClient.interceptors.response.use(
    response => {
        return response
    },
    function (error: Error) {
        return Promise.reject(error)
    }
);

apiClient.interceptors.response.use(
    response => {
        return response
    },
    function (error: Error) {
        console.log(error)
        if (error.response.status == 401 || error.response.status == 403){ // 401 은 토큰이 없는 상태, 혹은 토큰 만료,
            history.push({
                pathname: "/login"
            }, data);
            alert("사용자 인증이 만료되었습니다.")
            location.reload()
        }

        //400 및 기타에러는 화면에서 처리(axios 요청 실패시, 여러번 호출 되기 때문에 interceptor에서 처리 하지 않음)
        return Promise.reject(error)
    }
);
